<template>
	<layer class="opt_more_g" name="notice">
		<div class="box_opt_menu opt_menu_notice">
			<div class="menu_item">
				<a href="javascript:" class="link_menu" @click="callback('F')">게시판 공지로 지정</a>
			</div>
			<div class="menu_item" v-if="isAdmin">
				<a href="javascript:" class="link_menu" @click="callback('H')">전체 공지로 지정</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		isAdmin: {
			type: Boolean,
			default: false
		},
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
